import * as XLSX from 'xlsx';

export const generatePEOComparisonSpreadsheet = () => {
  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // PEO Comparison Sheet
  const comparisonData = [
    ['PEO COMPARISON TOOL', '', '', '', '', ''],
    ['Compare up to 5 PEO providers side-by-side', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['PROVIDER INFORMATION', 'Provider 1', 'Provider 2', 'Provider 3', 'Provider 4', 'Provider 5'],
    ['Company Name', '', '', '', '', ''],
    ['Sales Rep Name', '', '', '', '', ''],
    ['Sales Rep Email', '', '', '', '', ''],
    ['Sales Rep Phone', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['PRICING STRUCTURE', 'Provider 1', 'Provider 2', 'Provider 3', 'Provider 4', 'Provider 5'],
    ['Admin Fee (per employee/month)', '', '', '', '', ''],
    ['Admin Fee (% of payroll)', '', '', '', '', ''],
    ['Health Insurance Admin Fee', '', '', '', '', ''],
    ['Workers Comp Rate', '', '', '', '', ''],
    ['State Unemployment Rate', '', '', '', '', ''],
    ['Federal Unemployment Rate', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['ESTIMATED MONTHLY COSTS', 'Provider 1', 'Provider 2', 'Provider 3', 'Provider 4', 'Provider 5'],
    ['Number of Employees', 10, 10, 10, 10, 10],
    ['Average Monthly Payroll', 50000, 50000, 50000, 50000, 50000],
    ['Admin Fees (calculated)', '=IF(B11>0,B11*B19,B12*B20)', '=IF(C11>0,C11*B19,C12*B20)', '=IF(D11>0,D11*B19,D12*B20)', '=IF(E11>0,E11*B19,E12*B20)', '=IF(F11>0,F11*B19,F12*B20)'],
    ['Workers Comp Premium', '=B14*B20', '=C14*B20', '=D14*B20', '=E14*B20', '=F14*B20'],
    ['Unemployment Taxes', '=(B15+B16)*B20', '=(C15+C16)*B20', '=(D15+D16)*B20', '=(E15+E16)*B20', '=(F15+F16)*B20'],
    ['Health Insurance Admin', '', '', '', '', ''],
    ['TOTAL MONTHLY COST', '=B21+B22+B23+B24', '=C21+C22+C23+C24', '=D21+D22+D23+D24', '=E21+E22+E23+E24', '=F21+F22+F23+F24'],
    ['Cost Per Employee/Month', '=B25/B19', '=C25/B19', '=D25/B19', '=E25/B19', '=F25/B19'],
    ['', '', '', '', '', ''],
    ['SERVICES INCLUDED', 'Provider 1', 'Provider 2', 'Provider 3', 'Provider 4', 'Provider 5'],
    ['HR Support', '', '', '', '', ''],
    ['Payroll Processing', '', '', '', '', ''],
    ['Benefits Administration', '', '', '', '', ''],
    ['Workers Comp Management', '', '', '', '', ''],
    ['Compliance Support', '', '', '', '', ''],
    ['Employee Handbook', '', '', '', '', ''],
    ['Training Programs', '', '', '', '', ''],
    ['Performance Management Tools', '', '', '', '', ''],
    ['Time & Attendance System', '', '', '', '', ''],
    ['HRIS Access', '', '', '', '', ''],
    ['Risk Management', '', '', '', '', ''],
    ['Safety Programs', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['HEALTH INSURANCE OPTIONS', 'Provider 1', 'Provider 2', 'Provider 3', 'Provider 4', 'Provider 5'],
    ['Number of Plan Options', '', '', '', '', ''],
    ['Lowest Cost Plan (Employee)', '', '', '', '', ''],
    ['Highest Cost Plan (Employee)', '', '', '', '', ''],
    ['Family Coverage Available', '', '', '', '', ''],
    ['Dental Insurance Available', '', '', '', '', ''],
    ['Vision Insurance Available', '', '', '', '', ''],
    ['HSA Options Available', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['IMPLEMENTATION', 'Provider 1', 'Provider 2', 'Provider 3', 'Provider 4', 'Provider 5'],
    ['Implementation Timeline', '', '', '', '', ''],
    ['Implementation Cost', '', '', '', '', ''],
    ['Dedicated Implementation Rep', '', '', '', '', ''],
    ['Data Migration Included', '', '', '', '', ''],
    ['Training Provided', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['CONTRACT TERMS', 'Provider 1', 'Provider 2', 'Provider 3', 'Provider 4', 'Provider 5'],
    ['Contract Length', '', '', '', '', ''],
    ['Termination Notice Required', '', '', '', '', ''],
    ['Termination Fees', '', '', '', '', ''],
    ['Rate Guarantee Period', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['OVERALL RATING (1-10)', 'Provider 1', 'Provider 2', 'Provider 3', 'Provider 4', 'Provider 5'],
    ['Cost Competitiveness', '', '', '', '', ''],
    ['Service Quality', '', '', '', '', ''],
    ['Technology Platform', '', '', '', '', ''],
    ['Sales Experience', '', '', '', '', ''],
    ['References/Reviews', '', '', '', '', ''],
    ['TOTAL SCORE', '=SUM(B60:B64)', '=SUM(C60:C64)', '=SUM(D60:D64)', '=SUM(E60:E64)', '=SUM(F60:F64)'],
    ['', '', '', '', '', ''],
    ['NOTES/COMMENTS', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['', '', '', '', '', ''],
    ['', '', '', '', '', '']
  ];

  const comparisonSheet = XLSX.utils.aoa_to_sheet(comparisonData);

  // Set column widths
  comparisonSheet['!cols'] = [
    { wch: 25 }, // Column A
    { wch: 15 }, // Column B
    { wch: 15 }, // Column C
    { wch: 15 }, // Column D
    { wch: 15 }, // Column E
    { wch: 15 }  // Column F
  ];

  // Style headers
  const headerStyle = {
    font: { bold: true, color: { rgb: "FFFFFF" } },
    fill: { fgColor: { rgb: "4CAF50" } },
    alignment: { horizontal: "center" }
  };

  const subHeaderStyle = {
    font: { bold: true },
    fill: { fgColor: { rgb: "E8F5E8" } },
    alignment: { horizontal: "left" }
  };

  // Apply styles to headers
  if (comparisonSheet['A1']) comparisonSheet['A1'].s = { ...headerStyle, font: { ...headerStyle.font, sz: 16 } };
  if (comparisonSheet['A2']) comparisonSheet['A2'].s = { font: { italic: true } };

  // Style section headers
  ['A4', 'A10', 'A18', 'A28', 'A40', 'A47', 'A53', 'A59'].forEach(cell => {
    if (comparisonSheet[cell]) comparisonSheet[cell].s = subHeaderStyle;
  });

  // Add sheet to workbook
  XLSX.utils.book_append_sheet(workbook, comparisonSheet, 'PEO Comparison');

  // Questions to Ask Sheet
  const questionsData = [
    ['QUESTIONS TO ASK PEO PROVIDERS', '', ''],
    ['Use this checklist during sales calls and demos', '', ''],
    ['', '', ''],
    ['PRICING & COSTS', 'Provider 1', 'Provider 2'],
    ['What is your admin fee structure?', '', ''],
    ['Are there any setup or implementation fees?', '', ''],
    ['How do you handle rate increases?', '', ''],
    ['What is included in your base package?', '', ''],
    ['Are there additional fees for HR support?', '', ''],
    ['How do you price workers compensation?', '', ''],
    ['What are your unemployment tax rates?', '', ''],
    ['', '', ''],
    ['SERVICES & SUPPORT', 'Provider 1', 'Provider 2'],
    ['What HR services are included?', '', ''],
    ['Do you provide compliance support?', '', ''],
    ['What is your client-to-HR rep ratio?', '', ''],
    ['How do you handle employee issues?', '', ''],
    ['Do you provide safety and risk management?', '', ''],
    ['What training programs do you offer?', '', ''],
    ['How do you handle workplace investigations?', '', ''],
    ['', '', ''],
    ['TECHNOLOGY & SYSTEMS', 'Provider 1', 'Provider 2'],
    ['What HRIS platform do you use?', '', ''],
    ['Is employee self-service available?', '', ''],
    ['How do you handle time and attendance?', '', ''],
    ['What reporting capabilities do you offer?', '', ''],
    ['Do you integrate with our current systems?', '', ''],
    ['How do employees access their information?', '', ''],
    ['What mobile capabilities do you have?', '', ''],
    ['', '', ''],
    ['BENEFITS & INSURANCE', 'Provider 1', 'Provider 2'],
    ['How many health plan options do you offer?', '', ''],
    ['What is your claims experience?', '', ''],
    ['Do you offer dental and vision?', '', ''],
    ['Are HSA options available?', '', ''],
    ['How do you handle benefits enrollment?', '', ''],
    ['What is your benefits renewal process?', '', ''],
    ['Do you offer voluntary benefits?', '', ''],
    ['', '', ''],
    ['IMPLEMENTATION & TRANSITION', 'Provider 1', 'Provider 2'],
    ['What is your typical implementation timeline?', '', ''],
    ['Who will manage our implementation?', '', ''],
    ['How do you handle data migration?', '', ''],
    ['What training do you provide?', '', ''],
    ['How do you communicate with employees?', '', ''],
    ['What support is available during transition?', '', ''],
    ['', '', ''],
    ['CONTRACT & RELATIONSHIP', 'Provider 1', 'Provider 2'],
    ['What is your contract length?', '', ''],
    ['What notice is required for termination?', '', ''],
    ['Are there termination fees?', '', ''],
    ['How do you handle contract renewals?', '', ''],
    ['What is your client retention rate?', '', ''],
    ['Can you provide client references?', '', ''],
    ['How do you handle disputes?', '', ''],
    ['', '', ''],
    ['RED FLAGS TO WATCH FOR', '', ''],
    ['• Unwilling to provide references', '', ''],
    ['• Vague pricing or hidden fees', '', ''],
    ['• Poor technology demonstration', '', ''],
    ['• High-pressure sales tactics', '', ''],
    ['• Limited service offerings', '', ''],
    ['• Poor responsiveness during sales process', '', ''],
    ['• No clear implementation plan', '', '']
  ];

  const questionsSheet = XLSX.utils.aoa_to_sheet(questionsData);
  questionsSheet['!cols'] = [{ wch: 40 }, { wch: 20 }, { wch: 20 }];

  XLSX.utils.book_append_sheet(workbook, questionsSheet, 'Questions to Ask');

  // Cost Calculator Sheet
  const calculatorData = [
    ['PEO COST CALCULATOR', '', ''],
    ['Enter your information to estimate costs', '', ''],
    ['', '', ''],
    ['YOUR COMPANY INFO', 'Value', 'Notes'],
    ['Number of Employees', 10, 'Full-time equivalent'],
    ['Annual Payroll', 600000, 'Total gross payroll'],
    ['Monthly Payroll', '=B6/12', 'Calculated automatically'],
    ['Current Workers Comp Rate', 0.02, 'Current rate (e.g. 0.02 = 2%)'],
    ['Current Admin Costs/Month', 2000, 'Current HR/admin costs'],
    ['', '', ''],
    ['PEO COST ESTIMATES', 'Low End', 'High End'],
    ['Admin Fee (per employee)', 150, 250],
    ['Admin Fee (% of payroll)', 0.03, 0.08],
    ['Workers Comp Rate', 0.015, 0.025],
    ['', '', ''],
    ['CALCULATED COSTS', 'Low Estimate', 'High Estimate'],
    ['Monthly Admin Fee (per ee)', '=B12*B5', '=C12*B5'],
    ['Monthly Admin Fee (% payroll)', '=B13*B7', '=C13*B7'],
    ['Take Lower Admin Fee', '=MIN(B17,B18)', '=MIN(C17,C18)'],
    ['Workers Comp Premium', '=B14*B7', '=C14*B7'],
    ['Total Monthly PEO Cost', '=B19+B20', '=C19+C20'],
    ['Annual PEO Cost', '=B21*12', '=C21*12'],
    ['', '', ''],
    ['COST COMPARISON', 'Current', 'PEO Low', 'PEO High'],
    ['Monthly HR/Admin Costs', '=B9', '=B21', '=C21'],
    ['Annual HR/Admin Costs', '=B25*12', '=B25*12', '=C25*12'],
    ['Potential Monthly Savings', '', '=B25-B21', '=B25-C21'],
    ['Potential Annual Savings', '', '=B27*12', '=C27*12'],
    ['', '', '', ''],
    ['NOTES:', '', '', ''],
    ['• These are estimates only', '', '', ''],
    ['• Actual costs vary by provider', '', '', ''],
    ['• Benefits costs not included', '', '', ''],
    ['• Consider service value vs. cost', '', '', '']
  ];

  const calculatorSheet = XLSX.utils.aoa_to_sheet(calculatorData);
  calculatorSheet['!cols'] = [{ wch: 30 }, { wch: 15 }, { wch: 15 }];

  XLSX.utils.book_append_sheet(workbook, calculatorSheet, 'Cost Calculator');

  // Generate and download the file
  const fileName = `PEO_Comparison_Tool_${new Date().toISOString().split('T')[0]}.xlsx`;
  XLSX.writeFile(workbook, fileName);
};